import { render, staticRenderFns } from "./main-section-user-management-list.vue?vue&type=template&id=8dd32704&scoped=true"
import script from "./main-section-user-management-list.vue?vue&type=script&lang=js"
export * from "./main-section-user-management-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd32704",
  null
  
)

export default component.exports